import { useState, useEffect, useCallback } from 'react';
import { supabase } from '@/lib/supabase/client';
import { useAuth } from '@/features/auth/AuthContext';

export type AppRole = 'free' | 'member' | 'admin';

export function useUserRole() {
  const { session } = useAuth();
  const user = session?.user;
  const [role, setRole] = useState<AppRole>('free');
  const [loading, setLoading] = useState(true);

  const fetchRole = useCallback(async () => {
    if (!user) {
      setRole('free');
      setLoading(false);
      return;
    }

    try {
      const { data, error } = await supabase.rpc('get_user_role', {
        _user_id: user.id,
      });

      if (error) throw error;
      setRole((data as string as AppRole) || 'free');
    } catch (error) {
      setRole('free');
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    fetchRole();
  }, [fetchRole]);

  const isMember = role === 'member' || role === 'admin';
  const isAdmin = role === 'admin';

  return { role, loading, isMember, isAdmin, refreshRole: fetchRole };
}
